import './App.css';
import React from "react";
import Main from "./components/pages/main/main";
import Auth from "./components/pages/auth/auth";
import MiniApp from "./components/pages/app/miniApp";
import Cabinet from "./components/pages/cabinet/cabinet";
import Profile from "./components/pages/profile/profile";
import Help from "./components/pages/help/Help";
import Apps from "./components/pages/apps/Apps";
import PaymentPage from "./components/pages/payment/payment";
import {Route, Routes} from "react-router-dom";
import './fonts/featuremono.css'
import Admin from "./components/pages/admin/admin";
import Servers from "./components/pages/admin/servers";
import Clients from "./components/pages/admin/clients";
import Payments from "./components/pages/admin/payments";

function App() {

    return (
        <Routes>
            <Route index element={<Main />}/>
            <Route path="/auth" element={<Auth />}/>
            <Route path='/app' element={<MiniApp />}/>
            <Route path='/cabinet' element={<Cabinet />}/>
            <Route path='/profile' element={<Profile />}/>
            <Route path='/help' element={<Help />}/>
            <Route path='/apps' element={<Apps />}/>
            <Route path='/payment' element={<PaymentPage />}/>
            <Route path='/admin' element={<Admin />}/>
            <Route path='/admin/servers' element={<Servers />}/>
            <Route path='/admin/clients' element={<Clients />}/>
            <Route path='/admin/payments' element={<Payments />}/>
        </Routes>
    );
}

export default App;
